/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportLotPlan
 */
export interface TransportLotPlan {
    /**
     * 入荷日
     * @type {Date}
     * @memberof TransportLotPlan
     */
    recDate: Date;
    /**
     * 輸送手段ID
     * @type {string}
     * @memberof TransportLotPlan
     */
    transportTypeId: string;
    /**
     * 輸送番号　※XX台目
     * @type {number}
     * @memberof TransportLotPlan
     */
    transportLotNo: number;
    /**
     * 商品コード
     * @type {string}
     * @memberof TransportLotPlan
     */
    itemCode: string;
    /**
     * 積載ケース数
     * @type {number}
     * @memberof TransportLotPlan
     */
    lotQuantity: number;
    /**
     * 積載量下限を満たしているかのフラグ
     * @type {boolean}
     * @memberof TransportLotPlan
     */
    minLoadCapacityFlg: boolean;
}

/**
 * Check if a given object implements the TransportLotPlan interface.
 */
export function instanceOfTransportLotPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recDate" in value;
    isInstance = isInstance && "transportTypeId" in value;
    isInstance = isInstance && "transportLotNo" in value;
    isInstance = isInstance && "itemCode" in value;
    isInstance = isInstance && "lotQuantity" in value;
    isInstance = isInstance && "minLoadCapacityFlg" in value;

    return isInstance;
}

export function TransportLotPlanFromJSON(json: any): TransportLotPlan {
    return TransportLotPlanFromJSONTyped(json, false);
}

export function TransportLotPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLotPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recDate': (new Date(json['rec_date'])),
        'transportTypeId': json['transport_type_id'],
        'transportLotNo': json['transport_lot_no'],
        'itemCode': json['item_code'],
        'lotQuantity': json['lot_quantity'],
        'minLoadCapacityFlg': json['min_load_capacity_flg'],
    };
}

export function TransportLotPlanToJSON(value?: TransportLotPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rec_date': (value.recDate.toISOString().substring(0,10)),
        'transport_type_id': value.transportTypeId,
        'transport_lot_no': value.transportLotNo,
        'item_code': value.itemCode,
        'lot_quantity': value.lotQuantity,
        'min_load_capacity_flg': value.minLoadCapacityFlg,
    };
}

